var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import authentication from "@irati/auth";
import medicalTracking from "@irati-tracking/medical";
import Landing from "../../../components/Landing";
import StepPage from "../../../components/StepPage";
import EmailStep from "../../../components/EmailStep";
import ProfileInformationStep from "../../../components/ProfileInformationStep";
export var GET_STARTED = "step.get_started";
export var SET_EMAIL = "step.set_email";
export var SET_PROFILE_INFO = "step.set_profile_info";
var GetStarted = /** @class */ (function (_super) {
    __extends(GetStarted, _super);
    function GetStarted(props) {
        var _this = _super.call(this, props) || this;
        _this.handleUpdateStep = function (step) {
            if (step === SET_EMAIL) {
                medicalTracking.viewStep(1);
            }
            else if (step === SET_PROFILE_INFO) {
                medicalTracking.viewStep(2);
            }
            _this.setState({ step: step });
        };
        _this.handleUpdateEmail = function (email) {
            _this.setState({ email: email });
        };
        _this.state = {
            step: GET_STARTED,
            email: authentication.user().email
        };
        medicalTracking.viewGetStarted();
        return _this;
    }
    GetStarted.prototype.render = function () {
        var onCreateMedicalUser = this.props.onCreateMedicalUser;
        var _a = this.state, step = _a.step, email = _a.email;
        if (step === GET_STARTED) {
            return React.createElement(Landing, { onUpdateStep: this.handleUpdateStep });
        }
        if (step === SET_EMAIL) {
            return (React.createElement(StepPage, { currentStep: 1 },
                React.createElement(EmailStep, { email: email, onUpdateEmail: this.handleUpdateEmail, onUpdateStep: this.handleUpdateStep })));
        }
        if (step === SET_PROFILE_INFO) {
            return (React.createElement(StepPage, { currentStep: 2 },
                React.createElement(ProfileInformationStep, { onUpdateStep: this.handleUpdateStep, onCreateMedicalUser: onCreateMedicalUser, email: email })));
        }
        return React.createElement("div", null, "Invalid Step");
    };
    return GetStarted;
}(Component));
export default GetStarted;
